module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "element element-non-bodymatter element-container-single element-type-also-by element-with-heading full-character-formatting",
    attrs: {
      "id": "also-by"
    }
  }, [_c('div', {
    staticClass: "heading heading-with-title heading-without-image"
  }, [_c('div', {
    staticClass: "heading-contents"
  }, [_c('div', {
    staticClass: "title-subtitle-block title-block-without-element-number"
  }, [_c('div', {
    staticClass: "element-number-block"
  }), _vm._v(" "), _c('div', {
    staticClass: "title-block"
  }, [_c('h1', {
    staticClass: "title case-mixed"
  }, [_vm._v("Books in the Order of the Dragon Series")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "text",
    attrs: {
      "id": "also-by-text"
    }
  }, [_c('p', {
    staticClass: "first first-in-chapter first-full-width also-by-content"
  }, [_c('span', {
    staticClass: "underline"
  }, [_vm._v("Main Books")])]), _vm._v(" "), _c('p', {
    staticClass: "subsq also-by-content"
  }, [_c('i', [_vm._v("All of the main stories have numbers in the title")])]), _vm._v(" "), _c('p', {
    staticClass: "subsq also-by-content"
  }, [_c('a', {
    staticClass: "content-external-link",
    attrs: {
      "href": "https://books2read.com/u/bw21nY",
      "target": "_blank"
    }
  }, [_vm._v("Zero Hour: Prequel Story")])]), _vm._v(" "), _c('p', {
    staticClass: "subsq also-by-content"
  }, [_c('a', {
    staticClass: "content-external-link",
    attrs: {
      "href": "https://books2read.com/u/3GxRla",
      "target": "_blank"
    }
  }, [_vm._v("Once Bitten")])]), _vm._v(" "), _c('p', {
    staticClass: "subsq also-by-content"
  }, [_c('a', {
    staticClass: "content-external-link",
    attrs: {
      "href": "https://books2read.com/u/brVo6Y",
      "target": "_blank"
    }
  }, [_vm._v("Twice as High")])]), _vm._v(" "), _c('p', {
    staticClass: "subsq also-by-content"
  }, [_c('a', {
    staticClass: "content-external-link",
    attrs: {
      "href": "https://books2read.com/3littlewords",
      "target": "_blank"
    }
  }, [_vm._v("Three Little Words")])]), _vm._v(" "), _c('p', {
    staticClass: "subsq also-by-content"
  }, [_c('a', {
    staticClass: "content-external-link",
    attrs: {
      "href": "https://books2read.com/u/49kq1W",
      "target": "_blank"
    }
  }, [_vm._v("Four Times the Fight")])]), _vm._v(" "), _c('hr', {
    staticClass: "implicit-break"
  }), _vm._v(" "), _c('p', {
    staticClass: "first first-in-section first-full-width also-by-content"
  }, [_c('span', {
    staticClass: "underline"
  }, [_vm._v("Side Stories")])]), _vm._v(" "), _c('p', {
    staticClass: "subsq also-by-content"
  }, [_c('a', {
    staticClass: "content-external-link",
    attrs: {
      "href": "https://books2read.com/u/m0OvOW",
      "target": "_blank"
    }
  }, [_vm._v("Charming Like A Wolf")])]), _vm._v(" "), _c('p', {
    staticClass: "subsq also-by-content"
  }, [_c('a', {
    staticClass: "content-external-link",
    attrs: {
      "href": "https://books2read.com/u/4DgXgO",
      "target": "_blank"
    }
  }, [_vm._v("A Vampire Gives No Quarter")])]), _vm._v(" "), _c('p', {
    staticClass: "subsq also-by-content"
  }, [_c('a', {
    staticClass: "content-external-link",
    attrs: {
      "href": "https://books2read.com/u/4DRVEe",
      "target": "_blank"
    }
  }, [_vm._v("Bite Me: A Vampire Night")])]), _vm._v(" "), _c('p', {
    staticClass: "subsq also-by-content"
  }, [_c('a', {
    staticClass: "content-external-link",
    attrs: {
      "href": "https://books2read.com/u/4XDK21",
      "target": "_blank"
    }
  }, [_vm._v("A Half-Cocked Vampire")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-723f19ac","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/booksintheorderofthedragonseries.vue
// module id = 66
// module chunks = 0